import cn from "classnames";

import useImgSet from "../../hooks/useImgSet";

import s from "./withLayoutSimple.module.scss";

function withLayoutSimple(
  Wrapped,
  showShape = true,
  showTexture = true,
  showFooter = true,
  showHouse = false
) {
  const getImgSet = useImgSet();

  function WithLayout(props) {
    const logoFooter = getImgSet("logo__footer");
    const house = getImgSet("house__alt", "png", s.house);

    return (
      <div className={s.root}>
        <div
          className={cn(s.back, {
            [s.back__textured]: showTexture,
          })}
        />
        {showShape && <div className={s.shape} />}
        <div className={s.inner}>
          {showHouse && house}
          <Wrapped {...props} />
        </div>
        {showFooter && <div className={s.footer}>{logoFooter}</div>}
      </div>
    );
  }

  WithLayout.displayName = `WithLayoutSimple-(${Wrapped.name})`;

  return WithLayout;
}

export default withLayoutSimple;
